// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3du1W","colBig":"styles_colBig__2UbXe","colSmall":"styles_colSmall__bWAMn"};